import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/engineering/materials/functions")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.materialFunctions,
      moduleDescriptor: routeMessages.engineering,
    },
  },
});
